export default __webpack_public_path__ + "fe98733e417f84b3d2142bd086ba7397.mp3";